import { useEffect } from 'react';

const useReportStepLoading = (isLoading: boolean, onLoadingChange?: (loading: boolean) => void) => {
    useEffect(() => {
        onLoadingChange?.(isLoading);
        return () => onLoadingChange?.(false);
    }, [isLoading, onLoadingChange]);
};

export default useReportStepLoading;
